import UiValidatedJsonModeMixin from "../../UiValidatedJsonModeMixin";

// @vue/component
export default {
  name: "ModeSingleReadOnly",
  mixins: [
    UiValidatedJsonModeMixin
  ],
};
